/**
 * The individual model that makes up the Indexes to search.
 * Was just using object literals but creating this for clarity.
 */


var SearchIndexModel = function( attrs, activeDocumentTextModel ) {

    this.text = attrs.text;
    this.textToSearch = attrs.textToSearch;
    this.words = attrs.words; // adjacent word models that we use to search
    this.numberWords = attrs.numberWords;

};


_.extend( SearchIndexModel.prototype, {

    /**
    * PageId x WordModels array from which to create the hits collection from the word model -- which must be at the page level.
    * ( with derived words, these may span pages ).
    * If span's pages, put the original words ( not the derived ones ) -- which which no were mainly used for the search.
    * **Will only be called for hits -- it's called for all of them **
    */

    getWordsByPage: function( activeDocumentDerivedWordModels ) {

        var pageIdByWordsArray = {};

        this.words.forEach( function(word) {

            if ( !word.get('isMultiPage') ) {

                var wordPgId = word.get('pageId');

                if ( !pageIdByWordsArray[wordPgId] ) {
                    pageIdByWordsArray[wordPgId] = [word];
                }  else {
                    // ( these could be derived words on the same page )
                    pageIdByWordsArray[wordPgId].push( word );
                }

            } else {

                // 'Derived' words that can span > 1 page:
                // Get the page id from the subwords ( note word.get('pageId') is an array but it doesn't say which words are where )

                word.get('subWordReferences').forEach(function( subWordModelReference ) {

                    // An alternative is storing clones of these models on the derivedWords array
                    // another alternative is storing the pgIds of the words on the xref at the word level
                    var subWordModel = activeDocumentDerivedWordModels.getOriginalWordModelById( subWordModelReference.originalId ),
                        subWordPageId = subWordModel.get('pageId');

                    // Now adding the 'original sub word models' -- can use page_level_key to identify either of them -- true???
                    // Need to use the sub-words so the hits are not mixed
                    if ( !pageIdByWordsArray[subWordPageId] ) {
                        pageIdByWordsArray[subWordPageId] = [subWordModel];
                    }  else {
                        // ( these could be derived words on the same page )
                        pageIdByWordsArray[subWordPageId].push( subWordModel );
                    }

                });

            }

        });

        return pageIdByWordsArray;


    }
});



module.exports = SearchIndexModel;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/SearchIndexModel.js
 ** module id = 659
 ** module chunks = 0
 **/